const NONE = {
    create: false, updateStatus: false, updateOther: false, assign: false, comment: false, readComments: false, export: false, delete: false,
    revealContact: false,
};
const ALL = {
    create: true, updateStatus: true, updateOther: true, assign: true, comment: true, readComments: true, export: true, delete: true,
    revealContact: true,
};
const CAPS = {
    SUPER_ADMIN: ALL,
    SUPPORT: { ...NONE, readComments: true },
    ADMIN: ALL,
    GESTIONNAIRE: { ...ALL, delete: false, revealContact: false },
    FIELD_AGENT: { ...NONE, create: true, updateStatus: true, comment: true, readComments: true },
    VIEWER: NONE,
};
export function reportCaps(role) {
    return role ? CAPS[role] : NONE;
}
//# sourceMappingURL=role-caps.js.map